<template>
  <el-row type="flex" justify="center">
    <el-col :span="8">
      <div class="grid-content bg-purple-light">
        <el-card v-loading="loading" class="box-card">
          <div slot="header" class="clearfix">
            Aftership Reconciliation Report
          </div>
          <el-form label-position="left" :model="form" :rules="rules" ref="form">
            <el-form-item label="Store" prop="region">
              <el-select v-model="form.region" placeholder="Select Store" style="width: 200px">
                <el-option
                    v-for="item in regionOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="Start Datetime" prop="start">
              <el-date-picker
                  v-model="form.start"
                  type="datetime"
                  placeholder="Select date and time">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="End Datetime" prop="end">
              <el-date-picker
                  v-model="form.end"
                  type="datetime"
                  placeholder="Select date and time">
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button :loading="loading" type="primary" @click="submitForm('form')">Generate</el-button>
            </el-form-item>
          </el-form>
        </el-card>
      </div>
    </el-col>
  </el-row>
</template>

<script>
import {notify} from "../../utils";
import axios from "../../repositories";

const defaultRegionOptions = [
  {
    value: 'ca',
    label: 'CA'
  }, {
    value: 'usa',
    label: 'USA'
  },
];

export default {
  name: "AftershipReconciliationReportGenerator",
  data() {
    return {
      form: {
        gateway: '',
        region: '',
        start: '',
        end: '',
      },
      rules: {
        region: { required: true, message: 'Required', trigger: 'change' },
        start: { required: true, message: 'Required', trigger: 'blur' },
        end: { required: true, message: 'Required', trigger: 'blur' },
      },
      regionOptions: defaultRegionOptions,
      loading: false,
    }
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          try {
            this.loading = true;
            axios.get('/aftership-returns/reports/aftership-reconciliation', {
              params: this.form,
            }).then((response) => {
              notify(response.data.message, 'success');
            }).catch((err) => {
              notify(err.message, 'danger');
            }).finally(() => {
              this.loading = false;
            });
          } catch (err) {
            if(err.response.data.errors) {
              notify(err.response.data.errors, 'danger');
            }
          }
        } else {
          notify('Please fill out the form.', 'danger');
        }
      });
    },
  },
}
</script>